/* Carrito: mostrar como producto normal los upsells agregados desde el carrito (quita _instant-hidden) */ (function(){var b=false;function fx(){if(b||!window.Instant||!Instant.api)return;b=true;Instant.api.getCart().then(function(c){var l=(c&&c.items||[]).filter(function(i){return i.properties&&i.properties['_instant-hidden']&&String(i.properties['_instant-ref']||'').indexOf('CART:')===0});var p=Promise.resolve();l.forEach(function(i){p=p.then(function(){var pr=Object.assign({},i.properties);delete pr['_instant-hidden'];return Instant.api.updateLine(i.key,{properties:pr})})});return p}).catch(function(){}).then(function(){b=false})}var of=window.fetch,t;window.fetch=function(){var u=String(arguments[0]&&arguments[0].url||arguments[0]||'');var r=of.apply(this,arguments);if(/\/cart\/(add|change|update)/.test(u)){r.then(function(){clearTimeout(t);t=setTimeout(fx,300)})}return r};window.addEventListener('load',function(){setTimeout(fx,800)})})();
/* Precios: signo $ pequeno y arriba (estilo .cur-sym) */ (function(){var re=/^(\s*)\$(\s?\d[\d.,]*\s*)$/;function css(){if(document.getElementById('cur-sym-css'))return;var st=document.createElement('style');st.id='cur-sym-css';st.textContent='.cur-wrap{display:inline;white-space:nowrap}.cur-sym{font-size:.55em;vertical-align:.6em;line-height:0;margin-right:.08em}';document.head.appendChild(st)}function run(){if(!document.body)return;css();var w=document.createTreeWalker(document.body,NodeFilter.SHOW_TEXT),n,l=[];while(n=w.nextNode()){var p=n.parentElement;if(!p||p.closest('script,style,textarea,input,select,option,.cur-wrap,.custom-free-shipping-bar'))continue;if(re.test(n.nodeValue))l.push(n)}l.forEach(function(n){var m=n.nodeValue.match(re);if(!m||!n.parentNode)return;var wr=document.createElement('span');wr.className='cur-wrap';var s=document.createElement('span');s.className='cur-sym';s.textContent='$';wr.appendChild(s);wr.appendChild(document.createTextNode(m[2].trim()));n.parentNode.replaceChild(wr,n)})}var t;function start(){run();new MutationObserver(function(){clearTimeout(t);t=setTimeout(run,60)}).observe(document.body,{childList:true,subtree:true,characterData:true})}if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',start)}else{start()}})();
/**
 * Collection Card Metafields — Instant
 * ------------------------------------
 * Lee los inputs ocultos de .custom-product-metafields dentro de cada card
 * y aplica:
 *   - .custom-primary-color   -> color de texto en .custom-collection-grid-item-color
 *   - .custom-secondary-color -> background de la card (.custom-collection-grid-item)
 *   - .custom-box-image       -> src de .custom-metafield-product-image img
 *
 * REQUISITO: el input .custom-box-image debe contener SOLO la URL de la imagen
 * (no un <img>). En el Liquid usa:
 *   value="{{ product.metafields.custom.empaque.value | image_url: width: 600 }}"
 */
(function () {
  'use strict';

  function applyCard(card) {
    const primary = card.querySelector('.custom-primary-color');
    const secondary = card.querySelector('.custom-secondary-color');
    const boxImage = card.querySelector('.custom-box-image');

    const primaryVal = primary ? primary.value.trim() : '';
    const secondaryVal = secondary ? secondary.value.trim() : '';
    const boxImageVal = boxImage ? boxImage.value.trim() : '';

    // Background de la card
    if (secondaryVal) {
      card.style.backgroundColor = secondaryVal;
    }

    // Color de texto en los elementos marcados
    if (primaryVal) {
      card.querySelectorAll('.custom-collection-grid-item-color').forEach((el) => {
        el.style.color = primaryVal;
        // por si el color va en un <p> hijo (rich-text de Instant)
        el.querySelectorAll('p').forEach((p) => { p.style.color = primaryVal; });
      });

      // Borde en los elementos marcados
      card.querySelectorAll('.custom-collection-grid-item-border').forEach((el) => {
        el.style.borderColor = primaryVal;
      });
    }

    // Imagen del empaque -> reemplaza el src (y limpia el srcset placeholder)
    if (isValidUrl(boxImageVal)) {
      const img = card.querySelector('.custom-metafield-product-image img');
      if (img) {
        img.removeAttribute('srcset'); // evita que el srcset viejo gane al src
        img.src = boxImageVal;
      }
    }

    // Marca la card como procesada (con o sin metafields).
    card.classList.add('loaded');
  }

  // Valida que el value sea una URL usable y no el "Liquid error ..." u otro texto.
  function isValidUrl(val) {
    if (!val) return false;
    return /^(https?:)?\/\//.test(val) || val.startsWith('/');
  }

  function applyAll(root) {
    (root || document).querySelectorAll('.custom-collection-grid-item').forEach(applyCard);
  }

  // Instant puede re-renderizar el grid (filtros, paginación, carga async).
  // Un observer mantiene las tarjetas nuevas actualizadas.
  function observe() {
    const grid = document.querySelector('.custom-collection-grid-content');
    if (!grid || !('MutationObserver' in window)) return;

    const obs = new MutationObserver((mutations) => {
      for (const m of mutations) {
        m.addedNodes.forEach((node) => {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches('.custom-collection-grid-item')) {
            applyCard(node);
          } else {
            applyAll(node);
          }
        });
      }
    });

    obs.observe(grid, { childList: true, subtree: true });
  }

  function init() {
    applyAll();
    observe();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();



/**
 * Pack Builder — Instant Shopify PDP (Tripack)
 * --------------------------------------------
 * Solo se activa si existe .custom-pdp-tripack.
 * - El producto de la PDP NO se agrega al carrito.
 * - El pack lo componen únicamente las 3 selecciones del usuario en los upsells.
 * - El ATC del upsell se convierte en quantity selector al seleccionarlo.
 */
(function () {
  'use strict';


  const DEFAULT_ITEMS = 3;
  let MAX_ITEMS = DEFAULT_ITEMS; // se sobreescribe en init() con .number-of-steps

  // Lee el número de productos del pack desde el metacampo del DOM.
  function readMaxItems() {
    const el = document.querySelector('.number-of-steps .metafield-number_integer')
            || document.querySelector('.number-of-steps');
    const n = el ? parseInt(String(el.textContent).replace(/[^\d]/g, ''), 10) : NaN;
    return Number.isFinite(n) && n > 0 ? n : DEFAULT_ITEMS;
  }

  function errorMsg() {
    return MAX_ITEMS === 1
      ? 'Debes seleccionar el producto para completar el pack.'
      : 'Debes seleccionar los ' + MAX_ITEMS + ' productos para completar el pack.';
  }


  const pack = new Map(); // variantId -> { id, qty, price }

  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));

  // La barra de la PDP, no la del cart drawer (comparten clases).
  function packBar() {
    return $$('.custom-build-your-qty-bar')
      .find((el) => !el.closest('.custom-free-shipping-bar')) || null;
  }

  function parsePrice(text) {
    if (!text) return 0;
    const digits = String(text).replace(/[^\d]/g, '');
    return digits ? parseInt(digits, 10) : 0;
  }

  function formatPrice(amount) {
    return '$' + amount.toLocaleString('es-CO');
  }

  function totalSelected() {
    let n = 0;
    pack.forEach((it) => { n += it.qty; });
    return n;
  }

  function updateDynamicPrice() {
    const target = $('.custom-pdp-dynamic-price');
    if (!target) return;
    let total = 0;
    pack.forEach((it) => { total += (it.price || 0) * it.qty; });
    target.textContent = formatPrice(total);
  }

  // --- Quantity selector ----------------------------------------------------
  function buildQtySelector(qty) {
    const wrap = document.createElement('div');
    wrap.className = 'custom-upsell-qty';
    wrap.innerHTML =
      '<button type="button" class="custom-upsell-qty-minus" aria-label="Quitar uno">−</button>' +
      '<span class="custom-upsell-qty-value">' + qty + '</span>' +
      '<button type="button" class="custom-upsell-qty-plus" aria-label="Agregar uno">+</button>';
    return wrap;
  }

  function renderCard(card) {
    const vid = card.getAttribute('data-instant-form-variant-id');
    const item = pack.get(vid);
    const holder = card.querySelector('.i39Fhr67rWlARG1vz') || card;
    const atc = holder.querySelector('.custom-upsell-pdp-atc');
    const qtyEl = holder.querySelector('.custom-upsell-qty');

    card.classList.toggle('selected', !!item);

    if (item) {
      if (atc) atc.style.display = 'none';
      if (qtyEl) {
        qtyEl.querySelector('.custom-upsell-qty-value').textContent = item.qty;
        // deshabilita "+" si ya no caben más productos
        qtyEl.querySelector('.custom-upsell-qty-plus')
          .toggleAttribute('disabled', totalSelected() >= MAX_ITEMS);
      } else {
        const sel = buildQtySelector(item.qty);
        sel.querySelector('.custom-upsell-qty-plus')
          .toggleAttribute('disabled', totalSelected() >= MAX_ITEMS);
        holder.appendChild(sel);
      }
    } else {
      if (qtyEl) qtyEl.remove();
      if (atc) atc.style.display = '';
    }
  }

  // --- UI: barra, bolitas, error -------------------------------------------
  function setError(show) {
    const anchor = $('.custom-primary-atc');
    if (!anchor || !anchor.parentNode) return;
    let el = $('.custom-tripack-error');
    if (show) {
      if (!el) {
        el = document.createElement('p');
        el.className = 'custom-tripack-error';
        anchor.parentNode.insertBefore(el, anchor.nextSibling);
      }
      el.textContent = errorMsg();
      el.style.display = '';
    } else if (el) {
      el.style.display = 'none';
    }
  }

  // Renderiza las bolitas dentro de la barra de la PDP,
  // repartidas de extremo a extremo (la 1 en 0%, la última en 100%).
  function ensureSteps() {
    const bar = packBar();
    if (!bar) return;
    if (bar.dataset.steps === String(MAX_ITEMS)) return;

    bar.dataset.steps = MAX_ITEMS;
    bar.querySelectorAll('.custom-build-your-qty-bar-progress-step')
       .forEach((el) => el.remove());

    for (let i = 1; i <= MAX_ITEMS; i++) {
      const dot = document.createElement('div');
      dot.className = 'custom-build-your-qty-bar-progress-step ' +
                      'custom-build-your-qty-bar-progress-step' + i;
      dot.style.left = (MAX_ITEMS > 1 ? (i - 1) / (MAX_ITEMS - 1) * 100 : 100) + '%';
      bar.appendChild(dot);
    }
  }

  // Renderiza un precio por step dentro de .custom-pdp-pack-labels.
  // El último = precio total de la PDP; los anteriores, la parte proporcional.
  function renderPackLabels() {
    const wrap = $('.custom-pdp-pack-labels');
    if (!wrap) return false;

    const priceEl = $('.custom-pdp-primary-price');
    const base = parsePrice(priceEl ? priceEl.textContent : '');
    if (!base) return false;

    // Evita repintar si nada cambió (Instant repinta el precio seguido).
    const stamp = base + ':' + MAX_ITEMS;
    if (wrap.dataset.stamp === stamp) return true;
    wrap.dataset.stamp = stamp;

    wrap.innerHTML = '';
    for (let i = 1; i <= MAX_ITEMS; i++) {
      const el = document.createElement('p');
      el.className = 'custom-pdp-pack-label custom-pdp-pack-label-' + i;
      el.textContent = formatPrice(Math.round(base * i / MAX_ITEMS));
      wrap.appendChild(el);
    }
    positionPackLabels();
    return true;
  }

  // Alinea cada label con su bolita, midiendo la barra en px.
  // Sirve aunque .custom-pdp-pack-labels tenga otro ancho que la barra.
  function positionPackLabels() {
    const wrap = $('.custom-pdp-pack-labels');
    const bar = packBar();
    if (!wrap || !bar) return;

    const wrapRect = wrap.getBoundingClientRect();
    const barRect = bar.getBoundingClientRect();
    if (!barRect.width) return;

    for (let i = 1; i <= MAX_ITEMS; i++) {
      const label = $('.custom-pdp-pack-label-' + i, wrap);
      if (!label) continue;

      const ratio = MAX_ITEMS > 1 ? (i - 1) / (MAX_ITEMS - 1) : 1;
      label.style.left = (barRect.left - wrapRect.left + ratio * barRect.width) + 'px';
      // extremos anclados al borde, intermedios centrados
      label.style.transform = i === 1 ? 'none'
        : (i === MAX_ITEMS ? 'translateX(-100%)' : 'translateX(-50%)');
    }

    thinPackLabels();
  }


  // Esconde los labels que se solapan. Prioridad: último, primero y el activo.
  function thinPackLabels() {
    const wrap = $('.custom-pdp-pack-labels');
    if (!wrap) return;

    const GAP = 6; // px mínimos entre labels

    const items = [];
    for (let i = 1; i <= MAX_ITEMS; i++) {
      const el = $('.custom-pdp-pack-label-' + i, wrap);
      if (!el) continue;
      el.classList.remove('is-hidden'); // medir con todos visibles
      items.push({ i, el });
    }
    if (items.length < 2) return;

    items.forEach((o) => { o.rect = o.el.getBoundingClientRect(); });
    if (!items[0].rect.width) return; // aún no hay layout

    // Orden de prioridad
    const order = [];
    const push = (n) => {
      const o = items.find((x) => x.i === n);
      if (o && order.indexOf(o) === -1) order.push(o);
    };
    push(MAX_ITEMS);
    push(1);
    const total = totalSelected();
    if (total > 0) push(Math.min(total, MAX_ITEMS));
    items.forEach((o) => { if (order.indexOf(o) === -1) order.push(o); });

    const kept = [];
    order.forEach((o) => {
      const collides = kept.some((k) =>
        o.rect.left < k.rect.right + GAP && o.rect.right + GAP > k.rect.left);
      if (collides) o.el.classList.add('is-hidden');
      else kept.push(o);
    });
  }


  function updateUI() {
    const total = totalSelected();
    const bar = packBar();

    const pct = MAX_ITEMS > 1
      ? Math.max(0, total - 1) / (MAX_ITEMS - 1) * 100
      : (total ? 100 : 0);

    const progress = bar && $('.custom-build-your-qty-bar-progress', bar);
    if (progress) progress.style.width = pct + '%';

    for (let i = 1; i <= MAX_ITEMS; i++) {
      const step = bar && $('.custom-build-your-qty-bar-progress-step' + i, bar);
      if (step) step.classList.toggle('active', total >= i);

      const label = $('.custom-pdp-pack-label-' + i);
      if (label) label.classList.toggle('active', total >= i);
    }

    $$('.custom-pdp-upsells').forEach(renderCard);

    // ATC principal: solo habilitado con el pack completo
    const complete = total === MAX_ITEMS;
    $$('.custom-primary-atc, .custom-secondary-atc').forEach((btn) => {
      btn.classList.toggle('disabled', !complete);
    });
    if (complete) setError(false);

    positionPackLabels();
    updateDynamicPrice();
  }

  // --- Clicks en upsells ----------------------------------------------------
  function handleUpsellClick(e) {
    const card = e.target.closest('.custom-pdp-upsells');
    if (!card) return;

    const vid = card.getAttribute('data-instant-form-variant-id');
    if (!vid) return;

    const minus = e.target.closest('.custom-upsell-qty-minus');
    const plus = e.target.closest('.custom-upsell-qty-plus');
    const trigger = e.target.closest('[data-instant-action-type="add-to-cart"]');
    if (!minus && !plus && !trigger) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    if (minus) {
      const item = pack.get(vid);
      if (!item) return;
      if (item.qty <= 1) pack.delete(vid);
      else item.qty -= 1;
    } else if (plus) {
      const item = pack.get(vid);
      if (!item || totalSelected() >= MAX_ITEMS) return;
      item.qty += 1;
    } else {

      if (pack.has(vid) || totalSelected() >= MAX_ITEMS) return;
      const priceEl = card.querySelector('.custom-pdp-upsell-price');
      const titleEl = card.querySelector('[data-instant-dynamic-content-source="TITLE"]');
      pack.set(vid, {
        id: vid,
        qty: 1,
        price: parsePrice(priceEl ? priceEl.textContent : ''),
        title: titleEl ? titleEl.textContent.trim() : ''
      });
    }

    updateUI();
  }

  // Variante del producto de la PDP (la del form raíz de Instant).
  function mainVariantId(btn) {
    return (btn && btn.getAttribute('data-instant-action-variant-id'))
        || ($('[data-instant-type="root"]') || {}).getAttribute?.('data-instant-form-variant-id')
        || null;
  }

  // Un slot por unidad: "Producto 1", "Producto 2", ...
  // El prefijo se puede cambiar con <div id="direct-atc" data-label="Jabón"></div>
  function buildProperties() {
    const holder = document.getElementById('direct-atc');
    const label = (holder && holder.dataset.label) || 'Producto';
    const props = {};
    let slot = 0;
    pack.forEach((it) => {
      for (let q = 0; q < it.qty; q++) {
        slot++;
        props[label + ' ' + slot] = it.title || it.id;
      }
    });
    return props;
  }

  // --- ATC principal --------------------------------------------------------
  function handlePrimaryATC(e) {
    const btn = e.target.closest('.custom-primary-atc, .custom-secondary-atc');
    if (!btn) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    if (totalSelected() !== MAX_ITEMS) {
      setError(true);
      const el = $('.custom-tripack-error');
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    const direct = !!document.getElementById('direct-atc');
    let items;

    if (direct) {
      // Un solo line item: el producto de la PDP con los nombres elegidos.
      const mainId = mainVariantId(btn);
      if (!mainId) return;
      items = [{ id: mainId, quantity: 1, properties: buildProperties() }];
    } else {
      items = [];
      pack.forEach((it) => items.push({ id: it.id, quantity: it.qty }));
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items })
    })
      .then((r) => r.json())
      .then(() => window.Instant?.api?.updateCart?.())
      .then(() => window.Instant?.api?.toggleCart?.())
      .catch((err) => {
        console.error('Error agregando el pack al carrito:', err);
        const href = btn.getAttribute('href');
        if (href) window.location.href = href;
      });
  }

  function observePrimaryPrice() {
    const priceEl = $('.custom-pdp-primary-price');
    if (!priceEl || !('MutationObserver' in window)) return;

    new MutationObserver(() => {
      if (renderPackLabels()) updateUI();
    }).observe(priceEl, { childList: true, characterData: true, subtree: true });
  }

  function setupStickyObserver() {
    const primary = $('.custom-primary-atc');
    const sticky = $('.custom-pdp-sticky-atc');
    if (!primary || !sticky) return;

    if (!('IntersectionObserver' in window)) {
      sticky.classList.add('active');
      return;
    }

    new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        sticky.classList.toggle('active', !entry.isIntersecting);
      });
    }, { threshold: 0 }).observe(primary);
  }

  function init() {
    if (!document.querySelector('.custom-pdp-tripack')) return; // guard

    MAX_ITEMS = readMaxItems();
    ensureSteps();
    renderPackLabels();
    observePrimaryPrice();

    // Reposiciona los labels cuando cambie el ancho de la barra.
    const bar = packBar();
    if (bar && 'ResizeObserver' in window) {
      new ResizeObserver(positionPackLabels).observe(bar);
    } else {
      window.addEventListener('resize', positionPackLabels);
    }
    window.addEventListener('load', positionPackLabels); // fuentes web ya cargadas

    document.addEventListener('click', handleUpsellClick, true);
    document.addEventListener('click', handlePrimaryATC, true);
    setupStickyObserver();
    updateUI();

    // Respaldo: si el metacampo o el precio llegan tarde, reconfigura.
    let tries = 0;
    const timer = setInterval(() => {
      const n = readMaxItems();
      if (n !== MAX_ITEMS) {
        MAX_ITEMS = n;
        while (totalSelected() > MAX_ITEMS) {
          const last = Array.from(pack.keys()).pop();
          const it = pack.get(last);
          if (it.qty > 1) it.qty -= 1; else pack.delete(last);
        }
        ensureSteps();
      }
      renderPackLabels();
      updateUI();
      if (++tries > 8) clearInterval(timer);
    }, 250);
  }


  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();



/**
 * Free Shipping Bar — Instant Cart Drawer
 * ---------------------------------------
 * Actualiza en vivo la barra de envío gratis del cart-drawer de Instant:
 *   - Texto .custom-cart-freeshipping-text ("Te faltan $X para / envío gratis"
 *     o un mensaje de logrado cuando el total >= umbral).
 *   - Ancho de .custom-build-your-qty-bar-progress (0% a 100%).
 *   - Posición (left) y clase .active de .custom-build-your-qty-bar-progress-step1,
 *     que ahora es la cabeza de la barra.
 *
 * Reacciona a cualquier cambio del carrito (agregar, modificar cantidad,
 * eliminar) sin recargar, vía:
 *   1) patch de fetch() a las rutas /cart/*  (Instant las usa por debajo).
 *   2) MutationObserver sobre el total que Instant repinta (respaldo).
 */
(function () {
  'use strict';

  // --- Config ---------------------------------------------------------------
  // Mensaje cuando ya se alcanzó el envío gratis.
  const FREE_MSG_LINE1 = '¡Genial! Tienes';
  const FREE_MSG_LINE2 = 'envío gratis';
  // step2 (bolita del extremo) se activa al llegar al 100%.
  // step1 (bolita inicial) queda siempre activa como base.

  // --- Helpers --------------------------------------------------------------
  const $ = (sel, ctx = document) => ctx.querySelector(sel);

  // "$119.700" -> 119700 (el punto es separador de miles, sin decimales).
  function parsePrice(text) {
    if (!text) return 0;
    const digits = String(text).replace(/[^\d]/g, '');
    return digits ? parseInt(digits, 10) : 0;
  }

  function formatPrice(amount) {
    return '$' + Math.max(0, amount).toLocaleString('es-CO');
  }

  // --- Núcleo: recalcular y pintar -----------------------------------------
  function update() {
    const bar = $('.custom-free-shipping-bar');
    if (!bar) return; // el drawer aún no está en el DOM

    // Total actual: lo pinta Instant en .custom-cart-freeshipping-current.
    const currentEl = $('.custom-cart-freeshipping-current', bar);
    const current = parsePrice(currentEl ? currentEl.textContent : '');

    // Umbral: el precio objetivo fijo del markup (segundo bloque de precio).
    const threshold = getThreshold(bar);
    if (!threshold) return;

    const remaining = threshold - current;
    const reached = remaining <= 0;

    // Texto
    const textEl = $('.custom-cart-freeshipping-text', bar);
    if (textEl) {
      const lines = textEl.querySelectorAll('p');
      if (reached) {
        if (lines[0]) lines[0].textContent = FREE_MSG_LINE1;
        if (lines[1]) lines[1].textContent = FREE_MSG_LINE2;
      } else {
        if (lines[0]) lines[0].textContent = 'Te faltan ' + formatPrice(remaining) + ' para';
        if (lines[1]) lines[1].textContent = 'envío gratis';
      }
    }

    // Barra (0% a 100%)
    const pct = Math.min(100, Math.max(0, (current / threshold) * 100));
    const progress = $('.custom-build-your-qty-bar-progress', bar);
    if (progress) progress.style.width = pct + '%';

    // Cabeza de la barra: sigue el progreso y se marca .active al lograrlo.
    const head = $('.custom-build-your-qty-bar-progress-step1', bar);
    if (head) {
      head.style.left = pct + '%';
      head.classList.toggle('active', reached);
    }

  }

  // El umbral es el <p>$119.700</p> fijo del markup (dentro del bloque de la
  // barra, hermano del total actual). Lo cacheamos porque no cambia.
  let cachedThreshold = 0;
  function getThreshold(bar) {
    if (cachedThreshold) return cachedThreshold;
    // El total actual está en .custom-cart-freeshipping-current; el umbral es
    // el otro precio del mismo bloque. Buscamos todos los precios y tomamos
    // el que NO es el actual.
    const currentEl = $('.custom-cart-freeshipping-current', bar);
    const priceNodes = bar.querySelectorAll('p, span, div');
    let max = 0;
    priceNodes.forEach((n) => {
      if (n === currentEl) return;
      // solo nodos "hoja" con texto tipo precio
      if (n.children.length) return;
      const v = parsePrice(n.textContent);
      if (v > max) max = v;
    });
    cachedThreshold = max;
    return cachedThreshold;
  }

  // --- Disparadores ---------------------------------------------------------
  // 1) Patch de fetch: recalcula tras cualquier request al carrito.
  function patchFetch() {
    const orig = window.fetch;
    if (!orig || orig.__fsbPatched) return;

    const patched = function (...args) {
      const url = (args[0] && args[0].url) || args[0] || '';
      const isCart = typeof url === 'string' && /\/cart\//.test(url);
      return orig.apply(this, args).then((res) => {
        if (isCart) {
          // Espera un tick para que Instant repinte el total antes de leerlo.
          setTimeout(update, 150);
          setTimeout(update, 500); // segundo intento por si el repintado tarda
        }
        return res;
      });
    };
    patched.__fsbPatched = true;
    window.fetch = patched;
  }

  // 2) MutationObserver sobre el total: si Instant lo repinta por cualquier
  //    otra vía, recalculamos igual.
  function observeTotal() {
    const bar = $('.custom-free-shipping-bar');
    const currentEl = bar && $('.custom-cart-freeshipping-current', bar);
    if (!currentEl) return false;

    const obs = new MutationObserver(() => update());
    obs.observe(currentEl, { childList: true, characterData: true, subtree: true });
    return true;
  }

  // El drawer de Instant puede montarse tarde. Reintenta enganchar el observer.
  function waitForDrawer(attempts = 0) {
    if (observeTotal()) {
      update();
      return;
    }
    if (attempts < 40) {
      setTimeout(() => waitForDrawer(attempts + 1), 250);
    }
  }

  // --- Init -----------------------------------------------------------------
  function init() {
    patchFetch();
    waitForDrawer();
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


/**
 * Active Nav Link
 * ---------------
 * Agrega la clase .active al <a> cuyo href coincide con la página actual.
 */
(function () {
  'use strict';

  function setActive() {
    // Normaliza quitando la barra final para comparar de forma consistente.
    const normalize = (path) => path.replace(/\/+$/, '') || '/';
    const current = normalize(window.location.pathname);

    document.querySelectorAll('a[href^="/collections/"]').forEach((link) => {
      const linkPath = normalize(new URL(link.href).pathname);
      link.classList.toggle('active', linkPath === current);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setActive);
  } else {
    setActive();
  }
})();


/**
 * Anchor scroll
 * -------------
 * Al hacer click en .custom-link-to-find, hace scroll suave hasta
 * .custom-section-find.
 */
(function () {
  'use strict';

  function onClick(e) {
    const trigger = e.target.closest('.custom-link-to-find');
    if (!trigger) return;

    const target = document.querySelector('.custom-section-find');
    if (!target) return;

    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  // Delegación en document: funciona aunque el link se renderice después.
  document.addEventListener('click', onClick);
})();


/**
 * Category Tabs — Instant
 * -----------------------
 * Al hacer click en .custom-category-link-N, marca como .active ese link y su
 * panel .custom-category-N, y quita .active de los demás links y paneles.
 */
(function () {
  'use strict';

  const COUNT = 3; // número de tabs (link-1..3 / category-1..3)

  function activate(index) {
    for (let i = 1; i <= COUNT; i++) {
      const link = document.querySelector('.custom-category-link-' + i);
      const panel = document.querySelector('.custom-category-' + i);
      const isActive = i === index;
      if (link) link.classList.toggle('active', isActive);
      if (panel) panel.classList.toggle('active', isActive);
    }
  }

  function onClick(e) {
    for (let i = 1; i <= COUNT; i++) {
      if (e.target.closest('.custom-category-link-' + i)) {
        activate(i);
        return;
      }
    }
  }

  // Delegación en document: funciona aunque Instant renderice tarde la section.
  document.addEventListener('click', onClick);
})();



/**
 * Tripack Bar Prices — Instant PDP
 * --------------------------------
 * Slot 1 = precio / 3, slot 2 = precio / 2, slot 3 = precio tal cual.
 * Instant repinta estos <p> (PRICE dinámico), así que se reaplica con observer.
 */
(function () {
  'use strict';

  const $ = (sel, ctx = document) => ctx.querySelector(sel);

  function parsePrice(text) {
    if (!text) return 0;
    const digits = String(text).replace(/[^\d]/g, '');
    return digits ? parseInt(digits, 10) : 0;
  }

  function formatPrice(amount) {
    return '$' + Math.round(amount).toLocaleString('es-CO');
  }

  let applying = false; // evita que nuestro propio write dispare el observer

  function apply() {
    const el1 = $('.custom-upsell-pdp-price-1');
    const el2 = $('.custom-upsell-pdp-price-2');
    const el3 = $('.custom-upsell-pdp-price-3');
    if (!el3) return false;

    // Base: lo que Instant acaba de pintar en el slot 3.
    // Si ya lo habíamos escrito nosotros, reusamos el guardado.
    let base = parsePrice(el3.textContent);
    if (el3.dataset.basePrice && !el3.dataset.dirty) {
      base = parseInt(el3.dataset.basePrice, 10);
    }
    if (!base) return false;

    el3.dataset.basePrice = base;

    applying = true;
    if (el1) el1.textContent = formatPrice(base / 3);
    if (el2) el2.textContent = formatPrice(base / 2);
    el3.textContent = formatPrice(base);
    // libera el flag después del tick del observer
    setTimeout(() => { applying = false; }, 0);

    return true;
  }

  function observe() {
    const els = [
      $('.custom-upsell-pdp-price-1'),
      $('.custom-upsell-pdp-price-2'),
      $('.custom-upsell-pdp-price-3')
    ].filter(Boolean);
    if (!els.length || !('MutationObserver' in window)) return;

    const obs = new MutationObserver(() => {
      if (applying) return;
      // Instant repintó: el slot 3 trae el precio real de nuevo.
      const el3 = $('.custom-upsell-pdp-price-3');
      if (el3) delete el3.dataset.dirty;
      apply();
    });

    els.forEach((el) => {
      obs.observe(el, { childList: true, characterData: true, subtree: true });
    });
  }

  function init() {
    if (!document.querySelector('.custom-pdp-tripack')) return;

    apply();
    observe();

    // Respaldo por si el primer pintado de Instant llega tarde.
    let tries = 0;
    const timer = setInterval(() => {
      if (apply() || ++tries > 20) clearInterval(timer);
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();